













































































































import { Vue, Component } from 'vue-property-decorator';
import { LessonListDTO } from '../../../../src_server/entity/dto/LessonListDTO';
import { Teacher } from '../../../../src_server/entity/generated/Teacher';
import { Communicate } from '../../../../src_server/entity/generated/Communicate';
import CommonDialog from '../../../components/organisms/CommonDialog.vue';
import { CommunicationMethod, methodValueToJa } from '../../../../src_server/biz/ActorType';
import { getTeacherSuffixInSession } from '../../../utils/building_trans';

@Component({
  components: {
    CommonDialog,
  },
})
export default class ProfileDialog extends Vue {
  private test = 'abc';
  private nickname = '';
  private tl: Teacher = new Teacher();
  private c = new Communicate();

  private hearing_type = '';
  private sign_language = '';
  private corresponding_sign_language = '';
  private pronunciation = '';
  private read_write_level = '';

  get teacherSuffix() {
    return getTeacherSuffixInSession();
  }

  public showByDto(dto: LessonListDTO) {
    this.tl = dto.teacher || new Teacher();
    this.c = dto.communicate || new Communicate();
    this.hearing_type = methodValueToJa(dto.communicate?.hearing_type as CommunicationMethod);
    this.sign_language = methodValueToJa(dto.communicate?.sign_language as CommunicationMethod);
    this.corresponding_sign_language = methodValueToJa(dto.communicate?.corresponding_sign_language as CommunicationMethod);
    this.pronunciation = methodValueToJa(dto.communicate?.pronunciation as CommunicationMethod);
    this.read_write_level = methodValueToJa(dto.communicate?.read_write_level as CommunicationMethod);
    (this.$refs['dialog'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['dialog'] as CommonDialog).hide();
  }
}
